const routes = require('next-routes')();

routes
  .add('index', '/:region(australia|philippines)?')
  .add('about', '/about')
  .add('get-involved', '/get-involved')
  .add('solutions', '/solutions')

  /* -- Accounts -- */
  .add('login', '/login')
  .add('account', '/account')
  .add('create-account', '/create-account')
  .add('verify-account', '/verify/:key')
  .add('forgot-password', '/forgot-password')
  .add('password-reset', '/password-reset/:key')

  /* -- Donations & Forms -- */
  .add('donate', '/donate/:id?')
  .add('payment', '/payment/:id')
  .add('become-a-courier', '/become-a-courier')
  .add('start-a-fundraiser', '/start-a-fundraiser')
  .add('thankyou', '/thanks/:id/:sub?')
  .add('thanks-payment', '/confirmation/:id')

  /* -- Fundraisers -- */
  .add('fundraisers-search', '/fundraisers/search/:searchQuery', 'fundraisers')
  .add('fundraisers', '/fundraisers/:filter(latest|most-funded|least-funded|all)?')
  .add('fundraisers/edit', '/fundraisers/:id(\\d+)-:slug([-\\w]+)/edit')
  .add('fundraisers/fundraiser-detail', '/fundraisers/:id(\\d+)-:slug([-\\w]+)')

  /* -- Programs -- */
  .add('programs-search', '/programs/search/:searchQuery', 'programs')
  .add('programs', '/programs/:filter(corporate|government|disaster|public-health|all)?')
  .add('programs/program-detail', '/programs/:projectId(\\d+)-:projectSlug([-\\w]+)')

  /* -- Couriers -- */
  .add('couriers/about', '/couriers/about')
  .add('couriers-search', '/couriers/search/:searchQuery', 'couriers')
  .add('couriers', '/couriers/:filter(latest|most-funded|least-funded|all)?')
  .add('couriers/edit', '/couriers/:id(\\d+)-:slug([-\\w]+)/edit')
  .add('couriers/courier-detail', '/couriers/:id(\\d+)-:slug([-\\w]+)')

  /* -- CWC -- */
  .add('clean-water-corps', '/clean-water-corps')
  .add('clean-water-corps/cwc-detail', '/clean-water-corps/:id(\\d+)-:slug([-\\w]+)')

  /* -- Partners -- */
  .add('partners/case-study', '/partners/:partner')
  .add('partners', '/partners')

  /* -- User Profile -- */
  .add('user', '/users/:id')

  /* -- General Pages -- */
  .add('page', '/:slug');

module.exports = routes;
